import React from "react";
import KycDocumentsUploadComponent from "./IndividualBidders/KycDocumentsUploadComponent";
import BidApplicationFormWithOutPD from "./IndividualBidders/BidApplicationFormWithOutPD";
import NITermsAndConditions from "./NITermsAndConditions";
import BidderBidApplicationDownloadComponent from "./IndividualBidders/BidderBidApplicationDownloadComponent";
import ApproverDetailsForm from "./IndividualBidders/ApproverDetailsForm";
import CompletedStepsComponent from "./IndividualBidders/CompletedStepsComponent";
import NIBiddingApplicationForm from "./NIBiddingApplicationForm";
interface OfflineKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
  requiresApproverDetails?: boolean;
}

export default function OfflineKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
  requiresApproverDetails = false,
}: OfflineKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <KycDocumentsUploadComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 1:
        return offlinePaymentValidation ? (
          <BidApplicationFormWithOutPD
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
          />
        ) : (
          <NIBiddingApplicationForm
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
            hideHeader={true}
          />
        );
      case 2:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="t_&_c"
          />
        );
      case 3:
        return (
          <BidderBidApplicationDownloadComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep={
              requiresApproverDetails ? "bid_application_download" : "completed"
            }
            requiresApproverDetails={requiresApproverDetails}
          />
        );
      case 4:
        return requiresApproverDetails ? (
          <ApproverDetailsForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        ) : (
          <CompletedStepsComponent bidderUuid={bidderUuid} />
        );
      case 5:
      case 6:
        return <CompletedStepsComponent bidderUuid={bidderUuid} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {activeStep !== 2 && (
        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-2 mb-4">
          <h4 className="font-bold text-lg font-openSans flex-1">
            {stepsTitles?.[activeStep]?.label}
          </h4>
          <div className="flex items-center flex-wrap text-[10px] sm:text-xs">
            <span className="text-brand-orange font-semibold">Offline KYC</span>
            <span className="text-gray-500 font-semibold pl-1">
              → Final bid application must be submitted at the bank.
            </span>
          </div>
        </div>
      )}
      {renderStepContent()}
    </div>
  );
}
